import confetti from "canvas-confetti";

const COLORS = [
  "#C48B97", "#E7CFD4", "#B9906E",
  "#C0C0C0", "#E0E4E8", "#8A8F94"
];

function originFromEl(originEl) {
  let origin = { x: 0.5, y: 0.4 };
  if (originEl && originEl.getBoundingClientRect) {
    const r = originEl.getBoundingClientRect();
    origin = {
      x: Math.min(0.98, Math.max(0.02, (r.left + r.width / 2) / window.innerWidth)),
      y: Math.min(0.98, Math.max(0.02, (r.top + r.height / 2) / window.innerHeight))
    };
  }
  return origin;
}

/**
 * Metallic silver + rose gold confetti burst.
 * intensity 1 = normal (standard task)
 * intensity 2 = 2x particles + wider spread (priority task)
 * intensity 3 = full celebration (last of the 3 daily priorities)
 */
export function metallicConfetti(originEl, intensity = 1) {
  const origin = originFromEl(originEl);
  const mult = intensity;

  // Primary burst
  confetti({
    particleCount: Math.round(70 * mult),
    spread: 70 + (intensity - 1) * 15,
    startVelocity: 40,
    gravity: 1.05,
    scalar: 0.95,
    ticks: 200,
    origin,
    colors: COLORS,
    shapes: ["square", "circle"],
    disableForReducedMotion: true
  });

  // Secondary sparkle wave
  setTimeout(() => {
    confetti({
      particleCount: Math.round(40 * mult),
      spread: 110 + (intensity - 1) * 30,
      startVelocity: 25,
      gravity: 0.9,
      scalar: 0.75,
      ticks: 240,
      origin,
      colors: COLORS,
      shapes: ["circle"],
      disableForReducedMotion: true
    });
  }, 120);

  if (intensity >= 3) {
    // Cannons from the sides
    setTimeout(() => {
      confetti({
        particleCount: 90, angle: 60, spread: 55, startVelocity: 55,
        origin: { x: 0.05, y: 0.7 }, colors: COLORS, ticks: 250, scalar: 1.05,
        disableForReducedMotion: true
      });
      confetti({
        particleCount: 90, angle: 120, spread: 55, startVelocity: 55,
        origin: { x: 0.95, y: 0.7 }, colors: COLORS, ticks: 250, scalar: 1.05,
        disableForReducedMotion: true
      });
    }, 250);
    // Final rain
    setTimeout(() => {
      confetti({
        particleCount: 120, spread: 160, startVelocity: 30,
        origin: { x: 0.5, y: 0.1 }, colors: COLORS, ticks: 300, gravity: 0.8, scalar: 1,
        disableForReducedMotion: true
      });
    }, 550);
  }
}
